import * as localStore from 'store/utils/localStorage';
import * as sessionStore from 'store/utils/sessionStorage';
import { SubmissionError } from 'redux-form';
import _get from 'lodash/get';

import Notify from 'store/utils/Notify';

export default class ErrorHandler {
  static parseErrorsIndented = indent => errors =>
    ErrorHandler.parseErrors(errors, indent);

  static handle401Cases = async () => {
    localStore.removeState('nlu');
    sessionStore.removeState('nlu');
    window.location.href = '/sign_in';
  };

  static handle403Cases = () => {
    window.location.href = '/no-access';
  };

  static handle404Cases = () => {
    window.location.href = '/not-found';
  };

  static handleSpecialCases = status => {
    if (status === 401) {
      ErrorHandler.handle401Cases();
    }
    if (status === 403) {
      ErrorHandler.handle403Cases();
    }
    if (status === 404) {
      ErrorHandler.handle404Cases();
    }
  };

  static indentation = indent => Array(indent).join(' ');

  static getNotificationError = error =>
    ErrorHandler.parseErrors(
      _get(error, 'response.data', 'It seems sth went wrong!!'),
      _get(error, 'response.status', 400),
    );

  static getDetailError = error =>
    ErrorHandler.parseErrors(
      _get(error, 'response.data.detail', 'It seems sth went wrong!!'),
      _get(error, 'response.status', 400),
    );

  static parseErrors = (errors, status, indent = 0) => {
    if (Array.isArray(errors)) {
      return errors.map(ErrorHandler.parseErrorsIndented(indent)).join(', ');
    }

    if (typeof errors === 'string') {
      return errors;
    }

    if (typeof errors === 'boolean') {
      return errors.toString();
    }

    if (typeof errors === 'object') {
      const ret = Object.keys(errors)
        .map(key => {
          const childErrors = ErrorHandler.parseErrors(
            errors[key],
            2 * (indent + 1),
          );
          const humanKey =
            key.charAt(0).toUpperCase() + key.slice(1).replace('_', ' ');
          return `${humanKey}: ${childErrors}`;
        })
        .join(`\n${ErrorHandler.indentation(indent)}`);

      ErrorHandler.handleSpecialCases(status);

      if (indent) {
        return ret !== '' ? `\n${ErrorHandler.indentation(indent)}${ret}` : '';
      }

      return ret;
    }

    return null;
  };

  static parseValidationError = response => {
    /* eslint-disable camelcase */
    const errData = response.data;

    if (errData.non_field_errors) {
      Notify.error({
        title: 'An error occurred',
        description: ErrorHandler.parseErrors(
          errData.non_field_errors.join(' '),
          response.status,
        ),
      });
    }

    /* eslint-disable prefer-destructuring */
    const fieldsErr = Object.keys(errData).reduce((res, key) => {
      if (key !== 'non_field_errors') {
        res[key] = errData[key];
      }

      return res;
    }, {});
    if (Object.keys(fieldsErr).length) {
      Notify.error({
        title: 'An error occurred',
        description: ErrorHandler.parseErrors(
          Object.values(errData)[0],
          response.status,
        ),
      });
      throw new SubmissionError(fieldsErr);
    }
  };
}
